import { defineMessages } from 'react-intl';

export default defineMessages({
    vendorsInvolved: {
        id: 'claim.views.claim-detail.claim.views.claim-detail.Vendors involved',
        defaultMessage: 'Vendors involved'
    },
    montanaAlertExt: {
        id: 'claim.views.claim-detail.claim.views.claim-detail.Montana Alert Ext',
        defaultMessage: 'Display of further information of this claim is restricted. For more details, please contact the assigned Adjuster.'
    }
});
